/* This file is auto-generated with codeGen.ts. DO NOT MANUALLY EDIT! */
export default {
    geoextension: new Date("2025-03-11T19:22:35.000+01:00"),
    vier: new Date("2022-12-23T15:12:30.000+01:00"),
    rolit: new Date("2023-07-18T20:50:36.000+02:00"),
    skipbo: new Date("2022-12-11T17:03:55.000+01:00"),
    "whereigo-cracker": new Date("2023-11-28T16:42:32.000+01:00"),
    "super-wonder-captain": new Date("2019-11-02T18:48:45.000+01:00"),
    rooster: new Date("2022-12-11T18:15:01.000+01:00"),
    pris: new Date("2020-04-08T18:20:17.000+02:00"),
    clonebook: new Date("2024-01-14T10:50:46.000+01:00"),
    billy: new Date("2022-12-11T15:19:32.000+01:00"),
    botbot: new Date("2023-04-15T20:08:22.000+02:00"),
    tetris: new Date("2022-12-14T15:27:12.000+01:00"),
    lalaland: new Date("2023-11-10T08:56:59.000+01:00"),
    "mens-erger-je-niet": new Date("2023-01-20T20:25:25.000+01:00"),
    wifilogin: new Date("2024-09-08T11:43:50.000+02:00"),
    zwemapp: new Date("2022-10-10T19:19:16.000+02:00"),
    paywall: new Date("2022-10-16T20:09:40.000+02:00"),
    zwemtijden: new Date("2023-10-22T11:53:03.000+02:00"),
    libvirtmanager: new Date("2024-07-01T19:56:54.000+02:00"),
    "k3s-generator": new Date("2024-08-13T16:10:46.000+02:00"),
    updater: new Date("2024-07-16T11:50:28.000+02:00"),
    rquery: new Date("2023-08-22T18:10:54.000+02:00"),
    rubend: new Date("2024-12-24T10:44:44.000+01:00"),
    zeroscale: new Date("2024-12-19T19:54:06.000+01:00"),
    queuetimes: new Date("2024-11-04T16:31:44.000+01:00"),
    pdf: new Date("2023-08-05T19:04:02.000+02:00"),
    ov: new Date("2025-04-12T09:19:19.000+02:00"),
    AOC: new Date("2023-12-19T18:01:56.000+01:00"),
    swimtimer: new Date("2023-12-24T16:00:41.000+01:00"),
    ovRepeater: new Date("2025-04-14T19:00:57.000+02:00"),
    "vite-gql-codegen": new Date("2024-08-23T19:34:53.000+02:00"),
    "rate-cache": new Date("2024-11-19T19:46:09.000+01:00")
} as Record<string, Date>;